import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { appConfig } from 'src/app/_core/config/app-config.const';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-privacy-settings',
  templateUrl: './privacy-settings.component.html',
  styleUrls: ['./privacy-settings.component.scss']
})
export class PrivacySettingsComponent implements OnInit {
  @Input() privacySettings: boolean = false;
  @Input() selectedPrivacyOption: string = 'public';
  @Input() isPasswordSet: boolean = false;
  @Input() pathwayId: string = '';
  @Input() isCreateMode: boolean = true;
  @Input() invitedEmails: any[] = [];
  @Input() currentUser: any = null;
  @Output() privacyOptionSelected = new EventEmitter<string>();
  @Output() passwordSet = new EventEmitter<any>();
  @Output() passwordRemoved = new EventEmitter<any>();
  @Output() passwordChanged = new EventEmitter<any>();
  @Output() inviteModalOpened = new EventEmitter<void>();
  @Output() invitesSent = new EventEmitter<any>();
  @Output() unlockPremiumModalOpened = new EventEmitter<void>();
  @Output() alertPopupOpened = new EventEmitter<string>();
  @Input() disablePremium: boolean = false;
  @Input() curateScreen: boolean = false;

  imgPath: string = '';
  alterMessage: string = '';
  privacyOptions = [
    {
      id: 'public',
      title: 'Public',
      description: 'Anyone can view this tangram',
      icon: 'globe',
      isPremium: false
    },
    {
      id: 'private',
      title: 'Private',
      description: 'Only you can view this tangram',
      icon: 'eye-slash',
      isPremium: true
    },
    {
      id: 'invite-only',
      title: 'Invite Only',
      description: 'Only invited people can view this tangram',
      icon: 'envelope',
      isPremium: true
    },
    {
      id: 'password-protected',
      title: 'Password Protected',
      description: 'Anyone with the password can view this tangram',
      icon: 'lock',
      isPremium: true
    }
  ];

  constructor(private modalService: NgbModal) { 
    this.imgPath = appConfig.imagePath;
  }

  ngOnInit(): void {
  }

  onPrivacyOptionSelect(optionId: string): void {
    const option = this.privacyOptions.find(option => option.id === optionId);
    if (option && option.isPremium && this.disablePremium) {
      return;
    }
    if (this.curateScreen) {
      this.alterMessage = "Great! Insert a hyperlink to access the premium feature.";
      this.alertPopupOpened.emit(this.alterMessage);
      return;
    }

    if (this.isPremiumFeature(optionId) && (!this.currentUser || !this.currentUser.subscriptionActive)) {
      this.unlockPremiumModalOpened.emit();
      return;
    }

    this.selectedPrivacyOption = optionId;
    this.privacyOptionSelected.emit(optionId);
  }

  isPremiumFeature(optionId: string): boolean {
    const option = this.privacyOptions.find(option => option.id === optionId);
    if(option){
      return option.isPremium;
    }
    return false;
  }

  onPasswordSet(event: any): void {
    this.passwordSet.emit(event);
  }

  onPasswordRemoved(event: any): void {
    this.passwordRemoved.emit(event);
  }

  onPasswordChanged(event: any): void {
    this.passwordChanged.emit(event);
  }

  openInviteModal(): void {
    this.inviteModalOpened.emit();
  }

  onInvitesSent(event: any): void {
    this.invitesSent.emit(event);
  }
}
